// Cart page quantity fields: same rules as the product page's stepper (see
// assets/product-quantity-availability.js), applied per cart line.
//   * digits only — no minus, plus, "e", decimals;
//   * a typed value above the line's ceiling (stock, or the merchant's order limit — rendered by
//     sections/main-cart-items.liquid as max / data-line-max) is pulled down to it immediately,
//     with a short "Due to availability" note under that line's stepper;
//   * empty, 0 or below-minimum values snap back to what the line already had (removing an item is
//     the trash button's job, not a side effect of typing 0 or pressing minus at 1).
//
// Runs in the capture phase, ahead of Dawn's CartItems 'change' handler (assets/cart.js), so by
// the time that handler reads the field the value is already valid — and a change that ends up
// equal to what's already in the cart is swallowed instead of triggering a pointless update.
//
// Delegated at document level: cart.js re-renders the whole items list after every update, so
// anything bound to today's inputs would die on the first quantity change.
(function () {
  var pending = null; // { key, text } — note to re-show after the next cart re-render

  function lineInput(target) {
    var input = target && target.closest && target.closest('.cart-item .quantity__input');
    return input && input.hasAttribute('data-msg-limit') ? input : null;
  }

  function noteFor(input) {
    var cell = input.closest('td, .cart-item');
    return cell && cell.querySelector('[data-cart-qty-note]');
  }

  function showNote(input, text) {
    var note = noteFor(input);
    if (!note) return;
    note.textContent = text;
    note.hidden = false;
    pending = { key: input.dataset.quantityLineKey, text: text };
  }

  function hideNote(input) {
    var note = noteFor(input);
    if (note) note.hidden = true;
    pending = null;
  }

  function limits(input) {
    var min = Math.max(1, parseInt(input.min, 10) || 1);
    var max = input.max !== '' ? parseInt(input.max, 10) : null;
    if (max !== null && isNaN(max)) max = null;
    return { min: min, max: max, current: parseInt(input.dataset.lineQty, 10) || min };
  }

  document.addEventListener('keydown', function (event) {
    if (!lineInput(event.target)) return;
    if (['-', '+', 'e', 'E', '.', ','].indexOf(event.key) !== -1) event.preventDefault();
  });

  document.addEventListener('input', function (event) {
    var input = lineInput(event.target);
    if (!input) return;
    var cleaned = input.value.replace(/[^0-9]/g, '');
    if (cleaned !== input.value) input.value = cleaned;

    var lim = limits(input);
    var value = parseInt(input.value, 10);
    if (!isNaN(value) && lim.max !== null && value > lim.max) {
      input.value = lim.max;
      showNote(input, input.dataset.msgLimit.replace(/\{n\}/g, lim.max));
    } else {
      hideNote(input);
    }
  });

  // Capture phase: settle the value before cart.js's own (debounced, bubbling) change handler.
  function settle(event) {
    var input = lineInput(event.target);
    if (!input) return;
    var lim = limits(input);
    var value = parseInt(input.value, 10);

    if (isNaN(value) || value < lim.min) {
      input.value = lim.current;
      event.stopPropagation(); // nothing to send: the field just went back to what the cart has
      return;
    }
    if (lim.max !== null && value > lim.max) {
      input.value = lim.max;
      showNote(input, input.dataset.msgLimit.replace(/\{n\}/g, lim.max));
      value = lim.max;
    }
    if (value === lim.current) event.stopPropagation();
  }

  document.addEventListener('change', settle, true);
  document.addEventListener('focusout', function (event) {
    var input = lineInput(event.target);
    if (!input) return;
    var value = parseInt(input.value, 10);
    var lim = limits(input);
    if (isNaN(value) || value < lim.min) input.value = lim.current;
  });

  // Stepper buttons: keep the +/- from ever leaving [min, max] (Dawn's own validateQtyRules only
  // greys the buttons out) and explain a refused "+" at the ceiling.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.cart-item .quantity__button');
      if (!button) return;
      var input = button.closest('quantity-input');
      input = input && input.querySelector('.quantity__input');
      if (!lineInput(input)) return;
      var lim = limits(input);
      var value = parseInt(input.value, 10) || lim.current;
      if (button.name === 'plus' && lim.max !== null && value >= lim.max) {
        event.stopImmediatePropagation();
        event.preventDefault();
        showNote(input, input.dataset.msgLimit.replace(/\{n\}/g, lim.max));
      } else if (button.name === 'minus' && value <= lim.min) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  // The cart swaps the items markup after every update, wiping the note — put it back. Watched via
  // a MutationObserver on the page rather than a pub/sub event, so it works whichever script did
  // the swap (cart.js on the page, or the drawer's own).
  var restoreTimer = null;
  function restorePending() {
    if (!pending) return;
    // The cart drawer's (hidden) copy of the same line shares this key — pick the page's own field.
    var input = document.querySelector(
      '.cart-item .quantity__input[data-msg-limit][data-quantity-line-key="' + pending.key + '"]'
    );
    if (!input) return;
    var note = noteFor(input);
    if (note && note.hidden) {
      note.textContent = pending.text;
      note.hidden = false;
    }
  }

  new MutationObserver(function () {
    if (!pending) return;
    window.clearTimeout(restoreTimer);
    restoreTimer = window.setTimeout(restorePending, 30);
  }).observe(document.body, { childList: true, subtree: true });

  // The note is a one-off explanation, not a permanent banner: gone after a few seconds.
  var clearTimer = null;
  var originalShow = showNote;
  showNote = function (input, text) {
    originalShow(input, text);
    window.clearTimeout(clearTimer);
    clearTimer = window.setTimeout(function () {
      var note = noteFor(input);
      if (note) note.hidden = true;
      pending = null;
    }, 6000);
  };
})();
